import { useEffect } from 'react'
import { axiosInstance } from 'src/network/adapter'
import { ApiEndPoints } from 'src/network/endpoints'
import { registerGoodsCategoryLabels } from 'src/utils/logisticsLabels'

/** Loads cargo_type labels once so goodsCategoryLabel() can resolve FR/EN from admin data. */
const GoodsCategoryLabelsBootstrap = () => {
  useEffect(() => {
    axiosInstance
      .get(ApiEndPoints.CATEGORY.list('cargo_type'))
      .then(response => {
        registerGoodsCategoryLabels(response?.data?.data?.categories || [])
      })
      .catch(() => {
        // Non-blocking: i18n / raw name fallbacks still apply
      })
  }, [])

  return null
}

export default GoodsCategoryLabelsBootstrap
